import { StateCreator, create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { AllowedProducts, ProductsLeft } from '../types'
import { DomainToServer } from 'Types/Domain'

export interface AddDomainsStore {
  domainsLeft: number | null
  productsLeft: ProductsLeft
  allDomainsInTable: DomainToServer[]
  selectedDomains: DomainToServer[]
  allowedProducts: AllowedProducts
  setDomainsLeft: (domains: number) => void
  setProductsLeft: (products: ProductsLeft) => void
  setAllDomainsInTable: (domains: DomainToServer[]) => void
  setSelectedDomains: (domains: DomainToServer[]) => void
  setAllowedProducts: (products: AllowedProducts) => void
}

const addDomainStore = (set: (fn: (state: AddDomainsStore) => AddDomainsStore) => void) => ({
  domainsLeft: null,
  productsLeft: {
    botZapping: 0,
    paidMarketing: 0,
  },
  allowedProducts: {
    paidMarketing: false,
    botZapping: false,
  },
  allDomainsInTable: [],
  selectedDomains: [],
  setDomainsLeft: (domains: number) =>
    set((state: AddDomainsStore) => ({
      ...state,
      domainsLeft: domains,
    })),
  setProductsLeft: (products: ProductsLeft) =>
    set((state: AddDomainsStore) => ({
      ...state,
      productsLeft: products,
    })),
  setAllDomainsInTable: (domains: DomainToServer[]) =>
    set((state: AddDomainsStore) => ({
      ...state,
      allDomainsInTable: domains,
    })),
  setSelectedDomains: (domains: DomainToServer[]) =>
    set((state: AddDomainsStore) => ({
      ...state,
      selectedDomains: domains,
    })),
  setAllowedProducts: (products: AllowedProducts) =>
    set((state: AddDomainsStore) => ({
      ...state,
      allowedProducts: products,
    })),
})

const useAddDomainStore = create<AddDomainsStore>()(
  devtools(
    addDomainStore as StateCreator<
      AddDomainsStore,
      [['zustand/devtools', never]],
      [],
      AddDomainsStore
    >
  )
)
export default useAddDomainStore
